import React from "react";
import { LoginActions } from "@Pages";
import { useDispatch } from "react-redux";
import { actions as authActions } from "@Store/Reducers/auth";

type TypeErrorMessages = {
    username: string;
    email: string;
    password: string;
    confirm_password: string;
    entityType: string;
    url: string;
};

const FormValidation = (initialState: any, validate: any, props: any) => {
    const dispatch = useDispatch<any>();

    const [values, setValues] = React.useState(initialState);
    const [errors, setErrors] = React.useState<TypeErrorMessages>({
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        entityType: "",
        url: "",
    });

    const [isSubmitting, setSubmitting] = React.useState(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        const modifiedValue =
            name !== "password" && name !== "confirm_password"
                ? value.toLowerCase()
                : value;
        setValues({
            ...values,
            [name]: modifiedValue,
        });
    };

    const handleUsernameEmail = (event: React.FocusEvent<HTMLInputElement>) => {
        dispatch(authActions.setAccountIsTaken(false));
        setSubmitting(false);
    };

    function handleSubmit(event: any) {
        event.preventDefault();

        const validationErrors = validate(values);
        let isDataValid =
            validationErrors.username === "" &&
            validationErrors.email === "" &&
            validationErrors.password === "" &&
            validationErrors.confirm_password === "" &&
            validationErrors.entityType === "" &&
            validationErrors.url === "";

        setErrors(validationErrors);
        setSubmitting(isDataValid);
        if (isDataValid) {
            dispatch(
                LoginActions.IsAccountTaken({
                    username: values.username,
                    password: values.password,
                    email: values.email,
                    entityType: values.entityType,
                    url: values.url,
                })
            );
        }
    }

    return {
        handleSubmit,
        handleChange,
        handleUsernameEmail,
        values,
        errors,
        isSubmitting,
    };
};

export default FormValidation;
